import React from "react";

import { BarProps } from "./Bar.types";

import "./Bar.scss";

const Bar: React.FC<BarProps> = ({ values, min, max, height, title }) => (
  <div data-testid="bar-chart" className="mp-charts-bar--main">
    {title && <div className="title">{title}</div>}
    <div className="chart-wrapper" style={{ height: height }}>
      {values.map((value, index) => {
        return (
          <div
            key={`barchart-bar-${index}`}
            className="bar"
            style={
              value.bgColor
                ? {
                    backgroundColor: value.bgColor,
                    height: `${(value.value / max) * 100}%`,
                  }
                : {
                    backgroundColor: "#f27277",
                    height: `${(value.value / max) * 100}%`,
                  }
            }
          />
        );
      })}
    </div>
  </div>
);

export default Bar;
